import { useState } from "react";
import { Trash2, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription,
  AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger,
} from "@/components/ui/alert-dialog";

export const AdminDeleteAccount = ({ restaurant, onDeleted }) => {
  const [busy, setBusy] = useState(false);

  const remove = async () => {
    setBusy(true);
    try {
      await api.delete(`/admin/users/${restaurant.owner_id}`);
      toast.success(`Account ${restaurant.owner_email} eliminato`);
      onDeleted(restaurant.owner_id);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Eliminazione non riuscita");
    } finally {
      setBusy(false);
    }
  };

  return (
    <AlertDialog>
      <AlertDialogTrigger asChild>
        <Button variant="ghost" size="sm" className="text-red-600 hover:bg-red-50 hover:text-red-700" data-testid={`admin-delete-${restaurant.id}`}>
          {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Trash2 className="h-4 w-4" />}
        </Button>
      </AlertDialogTrigger>
      <AlertDialogContent data-testid="admin-delete-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle>Eliminare l'account di {restaurant.owner_email}?</AlertDialogTitle>
          <AlertDialogDescription>
            Verranno cancellati definitivamente il ristorante <strong>{restaurant.name}</strong>, tutti i menù, i piatti, gli ordini,
            la lista d'attesa e le notifiche. L'eventuale abbonamento Stripe sarà annullato. L'operazione non è reversibile.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="admin-delete-cancel">Annulla</AlertDialogCancel>
          <AlertDialogAction onClick={remove} className="bg-red-600 hover:bg-red-700" data-testid="admin-delete-confirm">
            Elimina definitivamente
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
